import i18n from "../../../../i18n";
import Tables from 'src/class/Tables';


const configTable = () => {
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
            prop: "name",
            label: i18n.t('common_words.name'),
            minWidth: 170,
            sortable: true,
        },
        {
            prop: "unit",
            label: i18n.t('labor.unit'),
            minWidth: 90,
            sortable: true,
            align: 'center',
        },
        {
            prop: "eradication_name",
            label: i18n.t('common_words.detail'),
            minWidth: 90,
            sortable: true,
            align: 'center',
        },
        {
            prop: "order",
            label: i18n.t('common_words.order'),
            minWidth: 90,
            sortable: true,
            align: 'center',
        }
    ];

    return { Table };
};

export default configTable;

